import React from "react";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import { IoCloseOutline } from "react-icons/io5";
import visaLogo from "../../../assets/Visa.svg";
import masterLogo from "../../../assets/master.svg";
import styles from "./creditCardOption.module.css";

const BRAND_LOGOS = {
  Visa: visaLogo,
  Mastercard: masterLogo,
};

function BrandIcon({ brand }) {
  const logo = BRAND_LOGOS[brand];

  if (logo) {
    return <img src={logo} alt={brand} className={styles.brandLogo} />;
  }

  return (
    <span
      style={{
        fontWeight: 500,
        fontSize: "14px",
        color: "#333",
        marginRight: 6,
      }}
    >
      {brand || "Desconhecido"}
    </span>
  );
}

export default function CreditCardOption({
  card,
  selected,
  highlighted,
  onSelect,
  onDelete,
  whitelabel,
}) {
  const containerClass = `${styles.cardContainer} ${
    highlighted ? styles.cardContainerHighlighted : ""
  }`;

  return (
    <div className={containerClass} onClick={onSelect}>
      <Radio
        checked={selected}
        onChange={onSelect}
        sx={{
          padding: "8px",
          "& .MuiSvgIcon-root": { fontSize: 22 },
          color: whitelabel?.theme?.text_primary_color || "#333",
          "&.Mui-checked": {
            color: whitelabel?.theme?.button_primary_color || "#0b3275",
          },
        }}
      />
      <BrandIcon brand={card.brand} />
      <span
        className={`${styles.cardInfo} font-wl-500`}
        style={{ color: whitelabel?.theme?.text_primary_color }}
      >
        Final {card.last_four_digits}
      </span>
      <button
        className={styles.deleteButton}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(card.uuid);
        }}
        type="button"
        aria-label="Remover cartão"
      >
        <IoCloseOutline size={20} />
      </button>
    </div>
  );
}

BrandIcon.propTypes = {
  brand: PropTypes.string,
};

CreditCardOption.propTypes = {
  card: PropTypes.object,
  selected: PropTypes.bool,
  highlighted: PropTypes.bool,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  whitelabel: PropTypes.object,
};
